import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { initialDataList } from '@interfaces/commonInterfaces'
import moment from 'moment'

export interface IState {
  reportDetailList?: any
  reportOrderList?: any
  reloadReportDetailList?: string | null
  reloadReportOrderList?: string | null
}

const initialState: IState = {
  reportDetailList: initialDataList,
  reportOrderList: initialDataList,
  reloadReportDetailList: null,
  reloadReportOrderList: null,
}

export const reportDucks = createSlice({
  name: 'report',
  initialState,
  reducers: {
    

    getListReportDetail: (state: RootState, action: PayloadAction<any>) => {
      state.reportDetailList = { loading: true, queryStr: action.payload }
    },
    getListReportDetailSuccess: (state, action: PayloadAction<any>) => {
      state.reportDetailList = { loading: false, ...action.payload }
    },
    getListReportDetailFail: (state, action: PayloadAction<any>) => {
      state.reportDetailList = { loading: false, ...action.payload }
    },
    setReloadReportDetailList: (state: RootState) => {
      state.reloadReportDetailList = String(moment())
    },

    getListReportOrder: (state: RootState, action: PayloadAction<any>) => {
      state.reportOrderList = { loading: true, queryStr: action.payload }
    },
    getListReportOrderSuccess: (state, action: PayloadAction<any>) => {
      state.reportOrderList = { loading: false, ...action.payload }
    },
    getListReportOrderFail: (state, action: PayloadAction<any>) => {
      state.reportOrderList = { loading: false, ...action.payload }
    },
    setReloadReportOrderList: (state: RootState) => {
      state.reloadReportOrderList = String(moment())
    },

  },
})

// Action creators are generated for each case reducer function
export const {
  getListReportDetail,
  getListReportDetailSuccess,
  getListReportDetailFail,
  setReloadReportDetailList,
  getListReportOrder,
  getListReportOrderSuccess,
  getListReportOrderFail,
  setReloadReportOrderList,
} = reportDucks.actions

export default reportDucks.reducer
